import { injectable } from 'tsyringe';
import { OWSettingsGames } from '../../odk-ts/ow-settings-games';
import { IOWSettingsGamesWrapper } from 'app-core/src/interfaces/ow-wrappers/ow-settings-games-wrapper.interface';

// -----------------------------------------------------------------------------
@injectable()
export class OWSettingsGamesWrapper implements IOWSettingsGamesWrapper {
  public async getOverlayEnabled(gameId: number) {
    return OWSettingsGames.getOverlayEnabled(gameId);
  }
}
